$('.pijler__dropdown').on('click', function(event) {
  event.preventDefault();
  var $target = $('.dropdown__pijler');
  $target.slideToggle(450);
});

$('#confirm_read').on('click', function(event) {
  event.preventDefault();
  var $self = $(event.currentTarget);
  var pmId = $self.attr('data-pm');

  $.ajax({
    url: $confirmReadMessageRoute,
    data: {msg_id: pmId},
    method: 'POST',
    dataType: 'json',
    success: function() {
      $('.warning__actions').remove();
      $('.warning__item').slideUp(450);
      $('.warning__message').html($confirmedReadMessage);
      $('.warning__message').fadeIn('fast');
      setTimeout(function() {
        $(location).attr('href', '/');
      }, 2500);
    },
  });
});

$(document).ready(function() {
  'use strict';
  $('.privateMessage__row').each(function() {
    var msgId = $(this).attr('data-id');
    getExcerpt(msgId, $(this));
  });
});

/**
 * Returns the excerpt for a private message
 *
 * @param {int} msgId
 * @param {obj} self
 */
function getExcerpt(msgId, self) {
  $.ajax({
    url: '/pm/get/message/' + msgId,
    success: function(data) {
      self.find('.privateMessage__content--excerpt').
      html(data).
      animate({'opacity': 1});
    },
  });
}

/**
 * Shows the buttons
 */
function showButtons() {
  $('.privateMessage__toolbar--checkbox').hide();
  $('.privateMessage__toolbar--actions').delay(500).show();
}

/**
 * @param {obj} element
 * Hides the buttons
 */
function hideButtons(element) {
  if ( element.length === 0 || element === 0 ) {
    $('.privateMessage__toolbar--actions').hide();
    $('.privateMessage__toolbar--checkbox').delay(500).show();
  }
}

$('.privateMessage__checkbox').on('click', function(event) {
  event.stopPropagation();
  var $self = $(event.currentTarget);
  var $checkbox = $self.closest('.privateMessage__actions').
  find('#privateMessage__actions--mark');
  var $container = $self.parents('.privateMessage__row');
  $checkbox.trigger('click');

  if ( $self.hasClass('checked') ) {
    $self.removeClass('checked');
    $container.removeClass('checked');
    var count = $('.privateMessage__checkbox.checked').length;
    if(count === 0) {
      hideButtons($('.checkbox.checked'));
      $('.privateMessage__toolbar--actions').hide();
    }
  } else {
    $('.privateMessage__toolbar--actions').show();
    $container.addClass('checked');
    $self.addClass('checked');
    showButtons();
  }
});

$('.privateMessage__toolbar--markAll').on('click', function(e) {
  e.stopPropagation();
  var $self = $(this);
  var $checkbox = $('#privateMessage__toolbar--mark');
  var $container = $('.privateMessage__row');
  var $checkboxes = $('.privateMessage__checkbox');
  $checkbox.trigger('click');

  $container.addClass('checked');
  $self.addClass('checked');
  $checkboxes.addClass('checked');
  showButtons();
});

$('.showTooltip').keydown(function() {
  var $self = $(this);
  var amount = $self.val().length;
  var $tooltip = $('.input__tooltip--user');
  if ( amount > 3 ) {
    $tooltip.slideDown();
  }
  if ( amount === 0 ) {
    $tooltip.slideUp();
  }
});

$('.removeSelected').on('click', function() {
  var remArray = [];
  $('.privateMessage__row.checked').each(function() {
    // Assemble a list of ID's to be moved to trash
    remArray.push($(this).attr('data-id'));
  });

  $.ajax({
    url: '/pm/remove/selected',
    data: {messageIds: remArray},
    dataType: 'json',
    method: 'POST',
    success: function(data) {
      for ( var row in data ) {
        $('div[data-id="' + data[row] + '"]').slideUp();
      }

      // unmark all rows
      $('.privateMessage__row.checked').removeClass('checked');

      hideButtons(0);
    }
  });
});

$('.unreadSelected').on('click', function() {
  var remArray = [];
  $('.privateMessage__row.checked').each(function() {
    // Assemble a list of ID's to be marked as unread
    remArray.push($(this).attr('data-id'));
  });

  $.ajax({
    url: '/pm/mark/selected',
    data: {messageIds: remArray},
    dataType: 'json',
    method: 'POST',
    success: function(data) {
      for ( var row in data ) {
        $('div[data-id="' + data[row] + '"]').addClass('privateMessages__row--unread');
      }
      hideButtons(0);
      $('.privateMessage__checkbox.checked').removeClass('checked');
    },
  });
});

$('.returnSelected').on('click', function() {
  var remArray = [];
  $('.privateMessage__row.checked').each(function() {
    // Assemble a list of ID's to be undeleted
    remArray.push($(this).attr('data-id'));
  });

  $.ajax({
    url: '/pm/undo/selected',
    data: {messageIds: remArray},
    dataType: 'json',
    method: 'POST',
    success: function(data) {
      for ( var row in data ) {
        $('div[data-id="' + data[row] + '"]').slideUp();
      }
      hideButtons(0);
    }
  });
});

$('#show__menu').on('click', function() {
  'use strict';
  var $menu = $('.navigation__slidedown');
  if($menu.hasClass('open')) {
    $menu.animate({'left': '-100%'});
    $menu.removeClass('open');
  } else {
    $menu.addClass('open');
    $menu.animate({'left': '0'});
  }
});

